let configurationData;
let kcyorPage;
let configurationType = "Ring";

let typeBasedStrings = {
	"Pendant": {
		setting_collection_url: '/collections/pendants',
		button_text: 'Complete Your Pendant',
		center_stone_button_text: "Add Pendant"
	},
	"Ring": {
		setting_collection_url: '/collections/engagement-ring-settings',
		button_text: 'Complete Your Ring',
		center_stone_button_text: "Add Setting"
	}
}

if (sessionStorage.configurationType) {
	configurationType = sessionStorage.configurationType;
}

let urlParams = new URLSearchParams(window.location.search);

if (urlParams.get("configurationType")) {
	sessionStorage.configurationType = urlParams.get("configurationType").replaceAll('-', ' ');
	configurationType = urlParams.get("configurationType").replaceAll('-', ' ');
}

if (document.URL.includes("engagement-ring-settings") || document.URL.endsWith("-setting") || document.URL.includes("setting?variant")) {
	kcyorPage = "Setting";
	configurationType = "Ring";
	sessionStorage.configurationType = 'Ring';
} else if ($("#kcyor-diamond-info")[0] || document.URL.endsWith("-diamond") || document.URL.includes("center-stones")
    || document.URL.includes("-keyzar-moissanite") || document.URL.includes("-miossanite")
    || $('[data-stones-page]').length) {
  kcyorPage = "Stone";
} else if (document.querySelector('#kcyor-complete-ring-hidden-info')) {
  kcyorPage = "Complete";
} else if (document.URL.includes('pendant')) {
	kcyorPage = "Setting";
	configurationType = 'Pendant';
	sessionStorage.configurationType = 'Pendant';
} else if ($('[data-setting-page]')) {
    kcyorPage = "Setting";
    configurationType = "Ring";
    sessionStorage.configurationType = 'Ring';
}

// const addSettingButton = document.getElementById('add-setting');
// if (addSettingButton) addSettingButton.onclick = addSetting;

$(document).on('click', '#add-setting', function(e) {
  addSetting({}, $(this));
});

const addStoneButton = document.getElementById('add-stone');
if (addStoneButton) addStoneButton.onclick = addCenterStone;

let configUrl = 'https://kcyor.keyzarjewelry.com/api/v1/kcyor/ring-configurations';
if (configurationType == 'Pendant') {
	configUrl += '?settingType=pendant';
}

if ($('#main-ring-configuration-container').length) {
  let setting;
  let centerStone;
  let completeRing;
  let start_with = "None";

  $.ajax({
  url: configUrl,
  type: "GET",
  cache: false,
  crossDomain: true,
  xhrFields: {
    withCredentials: true,
  },
  }).then((res) => {
    //console.log(res.data);
    configurationData = res.data;

    if(configurationData.configuration) {
      if (configurationData.configuration.setting) {
        setting = configurationData.configuration.setting;
      }
      if (configurationData.configuration.center_stone) {
        centerStone = configurationData.configuration.center_stone;
      }
      if (configurationData.configuration.complete_ring) {
        completeRing = configurationData.configuration.complete_ring;
      }
      if (configurationData.configuration.start_with) {
        start_with = configurationData.configuration.start_with;
      }
    }

    if ((kcyorPage) && (kcyorPage == "Complete") && (!completeRing || (completeRing && completeRing.sku != document.getElementById('complete-ring-hidden-sku').value))) {
      console.log("Need to recover complete ring!")
	  	recoverCompleteProduct();
    } else {
      renderKCYOR(setting, centerStone, completeRing, start_with);
    }
  });
}

function renderKCYOR(setting, centerStone, completeRing, start_with) {
  $(".preloader").remove();

  const mainConfigElement = document.getElementById('main-ring-configuration-container');
  const stepOneElement = document.getElementById('step-one');
  const stepTwoElement = document.getElementById('step-two');
  const stepThreeElement = document.getElementById('step-three');
  const viewButtonElementStepOne = stepOneElement.getElementsByClassName("view-btn")[0];
  const removeButtonElementStepOne = stepOneElement.getElementsByClassName("remove-btn")[0];
  const viewButtonElementStepTwo = stepTwoElement.getElementsByClassName("view-btn")[0];
  const removeButtonElementStepTwo = stepTwoElement.getElementsByClassName("remove-btn")[0];
  const viewButtonElementStepThree = stepThreeElement.getElementsByClassName("view-btn")[0];

	mainConfigElement.setAttribute('data-config-type', configurationType);
	stepThreeElement.getElementsByClassName('step-name')[0].innerHTML = configurationType.toUpperCase();
      if (!setting && !centerStone) {
        mainConfigElement.setAttribute("class", "steps-wrap one");
        stepOneElement.getElementsByClassName("price")[0].innerHTML = "$0";
        stepTwoElement.getElementsByClassName("price")[0].innerHTML = "$0";
        stepThreeElement.setAttribute("class", "step three ring");
        stepThreeElement.getElementsByClassName("price")[0].innerHTML = "$0";

        if (kcyorPage && kcyorPage == "Setting") {
          stepOneElement.setAttribute("class", "step one setting active");
          stepOneElement.getElementsByClassName("step-title")[0].innerHTML = "Select your";
          stepOneElement.getElementsByClassName("step-name")[0].innerHTML = "SETTING";
          stepTwoElement.getElementsByClassName("step-title")[0].innerHTML = "Select your";
          stepTwoElement.getElementsByClassName("step-name")[0].innerHTML = "STONE";
          stepTwoElement.setAttribute("class", "step two stone");

        } else if (kcyorPage && kcyorPage == "Stone") {
          stepOneElement.setAttribute("class", "step one stone active");
          stepOneElement.getElementsByClassName("step-name")[0].innerHTML = "STONE";
          stepOneElement.getElementsByClassName("step-title")[0].innerHTML = "Select your";
          stepTwoElement.getElementsByClassName("step-name")[0].innerHTML = "SETTING";
          stepTwoElement.getElementsByClassName("step-title")[0].innerHTML = "Select your";
          stepTwoElement.setAttribute("class", "step two setting");
          if (!$('[data-product-add-cart-text]')?.text().toLowerCase().includes('sold out')) {
              $('[data-product-add-cart-text]')?.text(typeBasedStrings[configurationType].center_stone_button_text)
          }
		  theme.strings.addToCart = typeBasedStrings[configurationType].center_stone_button_text;
        }

      } else if (setting && !centerStone) {
        stepOneElement.getElementsByTagName("img")[0].setAttribute("src", setting.image_url);
        stepOneElement.getElementsByClassName("price")[0].innerHTML = "$" + setting.price.toLocaleString("en-US");

				for (var [key, value] of Object.entries(setting)) {
					var elementsToUpdate = stepOneElement.querySelectorAll(`[data-setting-key-value="${key}"]`);
					if(elementsToUpdate) {
						elementsToUpdate.forEach(function(elementToUpdate){
							elementToUpdate.innerHTML = value;
						});
					}
				}

        viewButtonElementStepOne.onclick = () => window.location.href = "/products/" + setting.handle + "?variant=" + setting.variant_id;
        stepOneElement.getElementsByClassName("step-title")[0].innerHTML = "Select your";
        stepOneElement.getElementsByClassName("step-name")[0].innerHTML = "SETTING";
        viewButtonElementStepTwo.onclick = undefined;
        removeButtonElementStepTwo.onclick = undefined;
        stepTwoElement.getElementsByClassName("step-title")[0].innerHTML = "Select your";
        stepTwoElement.getElementsByClassName("step-name")[0].innerHTML = "STONE";
        stepTwoElement.getElementsByClassName("price")[0].innerHTML = "$0";

        stepThreeElement.getElementsByClassName("price")[0].innerHTML = "$0";
        viewButtonElementStepThree.onclick = undefined;

        if (kcyorPage && kcyorPage == "Setting") {
          mainConfigElement.setAttribute("class", "steps-wrap one");
          stepOneElement.setAttribute("class", "step one setting active done");

          removeButtonElementStepOne.onclick = () => {
             removeSetting();
             setting = undefined;
             stepOneElement.setAttribute("class", "step one setting active");
             stepOneElement.getElementsByClassName("price")[0].innerHTML = "$0";
             viewButtonElementStepOne.onclick = undefined;
             removeButtonElementStepOne.onclick = undefined;
             stepOneElement.getElementsByTagName("img")[0].setAttribute("src", "");
           };
        } else if (kcyorPage && kcyorPage == "Stone") {
          mainConfigElement.setAttribute("class", "steps-wrap two");
          stepOneElement.setAttribute("class", "step one setting done");
          stepTwoElement.setAttribute("class", "step two stone active");
          $('[data-product-add-cart-text]')?.text(typeBasedStrings[configurationType].button_text)
					theme.strings.addToCart = typeBasedStrings[configurationType].button_text;

          removeButtonElementStepOne.onclick = () => {
             removeSetting();
             setting = undefined;
             mainConfigElement.setAttribute("class", "steps-wrap one");
             stepOneElement.setAttribute("class", "step one stone active");
             stepOneElement.getElementsByClassName("price")[0].innerHTML = "$0";
             stepOneElement.getElementsByTagName("img")[0].setAttribute("src", "");
             viewButtonElementStepOne.onclick = undefined;
             removeButtonElementStepOne.onclick = undefined;
             stepOneElement.getElementsByClassName("step-title")[0].innerHTML = "Select your";
             stepOneElement.getElementsByClassName("step-name")[0].innerHTML = "STONE";
             stepTwoElement.getElementsByClassName("step-name")[0].innerHTML = "SETTING";
             stepTwoElement.getElementsByClassName("step-title")[0].innerHTML = "Select your";
             stepTwoElement.setAttribute("class", "step two setting");
           };
        }

      } else if (centerStone && !setting) {
        stepOneElement.getElementsByClassName("price")[0].innerHTML = centerStone.isAvailable ? "$" + centerStone.price.toLocaleString("en-US") : "Sold out";
        viewButtonElementStepOne.onclick = () => window.location.href = "/products/" + centerStone.handle;
        stepOneElement.getElementsByTagName("img")[0].setAttribute("src", centerStone.image_url);

        if (centerStone.product_title.toLowerCase().includes('moissanite')) {
          stepOneElement.setAttribute('data-stone-type', 'moissanite');
        } else {
          stepOneElement.setAttribute('data-stone-type', 'diamond');
        }

				if (!centerStone.isAvailable) {
					stepOneElement.setAttribute('data-sold-out', true);
					stepOneElement.getElementsByClassName("step-title")[0].innerHTML = "Choose another";
					if (centerStone.product_title.toLowerCase().includes('moissanite')) {
						document.querySelector('[data-stone-not-available-link]').setAttribute('href', "/collections/loose-miossanite");
					}
				}

				for (var [key, value] of Object.entries(centerStone)) {
					var elementsToUpdate = stepOneElement.querySelectorAll(`[data-center-stone-key-value="${key}"]`);
					if(elementsToUpdate) {
						elementsToUpdate.forEach(function(elementToUpdate){
							elementToUpdate.innerHTML = value;
						});
					}
				}

				if (centerStone.product_title.toLowerCase().includes('moissanite')) {
					$('.step .mpsd-certificate-container').hide();
				} else {
					var certificate_lab = "IGI";
					if (centerStone.sku.includes("GIA")) {
						certificate_lab = "GIA";
					}
					stepOneElement.querySelector('[data-center-stone-certificate-image]').setAttribute('src', theme.certificateImages[certificate_lab]);
					stepOneElement.querySelector('[data-center-stone-certificate-url]').setAttribute('href', centerStone.certificate_url);
				}

        stepOneElement.getElementsByClassName("step-title")[0].innerHTML = "Select your";
        stepOneElement.getElementsByClassName("step-name")[0].innerHTML = "STONE";

        viewButtonElementStepTwo.onclick = undefined;
        removeButtonElementStepTwo.onclick = undefined;
        stepTwoElement.getElementsByClassName("step-title")[0].innerHTML = "Select your";
        stepTwoElement.getElementsByClassName("step-name")[0].innerHTML = "SETTING";
        stepTwoElement.getElementsByClassName("price")[0].innerHTML = "$0";
        stepThreeElement.getElementsByClassName("price")[0].innerHTML = "$0";
        viewButtonElementStepThree.onclick = undefined;

        if (kcyorPage && kcyorPage == "Setting") {
          mainConfigElement.setAttribute("class", "steps-wrap two");
          stepOneElement.setAttribute("class", "step one stone done");
          stepTwoElement.setAttribute("class", "step two setting active");
          $('[data-product-add-cart-text]')?.text(typeBasedStrings[configurationType].button_text)
					theme.strings.addToCart = typeBasedStrings[configurationType].button_text;

          removeButtonElementStepOne.onclick = () => {
             removeCenterStone();
             centerStone = undefined;
             mainConfigElement.setAttribute("class", "steps-wrap one");
             stepOneElement.setAttribute("class", "step one setting active");
             stepOneElement.getElementsByClassName("price")[0].innerHTML = "$0";
             stepOneElement.getElementsByTagName("img")[0].setAttribute("src", "");
             viewButtonElementStepOne.onclick = undefined;
             removeButtonElementStepOne.onclick = undefined;
             stepOneElement.getElementsByClassName("step-title")[0].innerHTML = "Select your";
             stepOneElement.getElementsByClassName("step-name")[0].innerHTML = "SETTING";
             stepTwoElement.getElementsByClassName("step-title")[0].innerHTML = "Select your";
             stepTwoElement.getElementsByClassName("step-name")[0].innerHTML = "STONE";
             stepTwoElement.setAttribute("class", "step two stone");
           };
        } else if (kcyorPage && kcyorPage == "Stone") {
          mainConfigElement.setAttribute("class", "steps-wrap one");
          stepOneElement.setAttribute("class", "step one stone active done");
          stepTwoElement.setAttribute("class", "step two setting");

          removeButtonElementStepOne.onclick = () => {
             removeCenterStone();
             centerStone = undefined;
             stepOneElement.setAttribute("class", "step one stone active");
             stepOneElement.getElementsByClassName("price")[0].innerHTML = "$0";
             viewButtonElementStepOne.onclick = undefined;
             removeButtonElementStepOne.onclick = undefined;
             stepOneElement.getElementsByTagName("img")[0].setAttribute("src", "");
           };
        }
      } else if (setting && centerStone) {
        if (start_with == "Setting") {
          stepOneElement.getElementsByClassName("step-title")[0].innerHTML = "Select your";
          stepOneElement.getElementsByClassName("step-name")[0].innerHTML = "SETTING";
          viewButtonElementStepOne.onclick = () => window.location.href = "/products/" + setting.handle + "?variant=" + setting.variant_id;
          stepOneElement.getElementsByClassName("price")[0].innerHTML =  "$" + setting.price.toLocaleString("en-US");
          stepOneElement.getElementsByTagName("img")[0].setAttribute("src", setting.image_url);

					for (var [key, value] of Object.entries(setting)) {
						var elementsToUpdate = stepOneElement.querySelectorAll(`[data-setting-key-value="${key}"]`);
						if(elementsToUpdate) {
							elementsToUpdate.forEach(function(elementToUpdate){
								elementToUpdate.innerHTML = value;
							});
						}
					}

          viewButtonElementStepTwo.onclick = () => window.location.href = "/products/" + centerStone.handle;
          stepTwoElement.getElementsByClassName("step-title")[0].innerHTML = "Select your";
          stepTwoElement.getElementsByClassName("step-name")[0].innerHTML = "STONE";
          stepTwoElement.getElementsByClassName("price")[0].innerHTML =  centerStone.isAvailable ? "$" + centerStone.price.toLocaleString("en-US") : "Sold out";
          stepTwoElement.getElementsByTagName("img")[0].setAttribute("src", centerStone.image_url);

          if (centerStone.product_title.toLowerCase().includes('moissanite')) {
            stepTwoElement.setAttribute('data-stone-type', 'moissanite');
          } else {
            stepTwoElement.setAttribute('data-stone-type', 'diamond');
          }

					if (!centerStone.isAvailable) {
						stepTwoElement.setAttribute('data-sold-out', true);
						stepTwoElement.getElementsByClassName("step-title")[0].innerHTML = "Choose another";
						if (centerStone.product_title.toLowerCase().includes('moissanite')) {
							document.querySelector('[data-stone-not-available-link]').setAttribute('href', "/collections/loose-miossanite");
						}
					}

					for (var [key, value] of Object.entries(centerStone)) {
						var elementsToUpdate = stepTwoElement.querySelectorAll(`[data-center-stone-key-value="${key}"]`);
						if(elementsToUpdate) {
							elementsToUpdate.forEach(function(elementToUpdate){
								elementToUpdate.innerHTML = value;
							});
						}
					}

					if (centerStone.product_title.toLowerCase().includes('moissanite')) {
						$('.step .mpsd-certificate-container').hide();
					} else {
						var certificate_lab = "IGI";
						if (centerStone.sku.includes("GIA")) {
							certificate_lab = "GIA";
						}
						stepTwoElement.querySelector('[data-center-stone-certificate-image]').setAttribute('src', theme.certificateImages[certificate_lab]);
						stepTwoElement.querySelector('[data-center-stone-certificate-url]').setAttribute('href', centerStone.certificate_url);
					}

          stepThreeElement.getElementsByClassName("price")[0].innerHTML =  "$" + completeRing.price.toLocaleString("en-US");
          stepThreeElement.getElementsByTagName("img")[0].setAttribute("src", setting.image_url);
					stepThreeElement.querySelector('.step-center-stone-status-title').innerHTML = completeRing.product_title;

          viewButtonElementStepThree.onclick = () => window.location.href = "/products/" + completeRing.handle;

          if (kcyorPage && kcyorPage == "Setting") {
            mainConfigElement.setAttribute("class", "steps-wrap one");
            stepOneElement.setAttribute("class", "step one setting active done");
            stepTwoElement.setAttribute("class", "step two stone done");
            stepThreeElement.setAttribute("class", "step three ring done");
            $('[data-product-add-cart-text]')?.text(typeBasedStrings[configurationType].button_text)
						theme.strings.addToCart = typeBasedStrings[configurationType].button_text;

            removeButtonElementStepOne.onclick = () => {
              if (setting && centerStone) {
                removeSetting();
                mainConfigElement.setAttribute("class", "steps-wrap two");
                stepOneElement.getElementsByClassName("step-title")[0].innerHTML = "Select your";
                stepOneElement.getElementsByClassName("step-name")[0].innerHTML = "STONE";
                stepOneElement.setAttribute("class", "step one stone done");
                stepOneElement.getElementsByTagName("img")[0].setAttribute("src", centerStone.image_url);
                stepOneElement.getElementsByClassName("price")[0].innerHTML =  centerStone.isAvailable ? "$" + centerStone.price.toLocaleString("en-US") : "Sold out";
                viewButtonElementStepOne.onclick = () => window.location.href = "/products/" + centerStone.handle;

                if (centerStone.product_title.toLowerCase().includes('moissanite')) {
                  stepOneElement.setAttribute('data-stone-type', 'moissanite');
                } else {
                  stepOneElement.setAttribute('data-stone-type', 'diamond');
                }

								if (!centerStone.isAvailable) {
									stepOneElement.setAttribute('data-sold-out', true);
									stepOneElement.getElementsByClassName("step-title")[0].innerHTML = "Choose another";
									if (centerStone.product_title.toLowerCase().includes('moissanite')) {
										document.querySelector('[data-stone-not-available-link]').setAttribute('href', "/collections/loose-miossanite");
									}
								}

								for (var [key, value] of Object.entries(centerStone)) {
									var elementsToUpdate = stepOneElement.querySelectorAll(`[data-center-stone-key-value="${key}"]`);
									if(elementsToUpdate) {
										elementsToUpdate.forEach(function(elementToUpdate){
											elementToUpdate.innerHTML = value;
										});
									}
								}

								if (centerStone.product_title.toLowerCase().includes('moissanite')) {
									$('.step .mpsd-certificate-container').hide();
								} else {
									var certificate_lab = "IGI";
									if (centerStone.sku.includes("GIA")) {
										certificate_lab = "GIA";
									}
									stepOneElement.querySelector('[data-center-stone-certificate-image]').setAttribute('src', theme.certificateImages[certificate_lab]);
									stepOneElement.querySelector('[data-center-stone-certificate-url]').setAttribute('href', centerStone.certificate_url);
								}

                stepTwoElement.getElementsByClassName("step-title")[0].innerHTML = "Select your";
                stepTwoElement.getElementsByClassName("step-name")[0].innerHTML = "SETTING";
                stepTwoElement.setAttribute("class", "step two setting active");
                stepTwoElement.getElementsByTagName("img")[0].setAttribute("src", "");
                stepTwoElement.getElementsByClassName("price")[0].innerHTML = "$0";
                viewButtonElementStepTwo.onclick = undefined;
                removeButtonElementStepTwo.onclick = undefined;
                stepThreeElement.setAttribute("class", "step three ring");
                stepThreeElement.getElementsByClassName("price")[0].innerHTML = "$0";
                stepThreeElement.getElementsByTagName("img")[0].setAttribute("src", "");
                viewButtonElementStepThree.onclick = undefined;

                removeButtonElementStepOne.onclick = () => {
                  removeCenterStone();
                  mainConfigElement.setAttribute("class", "steps-wrap one");
                  stepOneElement.setAttribute("class", "step one setting active");
                  stepOneElement.getElementsByClassName("price")[0].innerHTML = "$0";
                  stepOneElement.getElementsByClassName("step-title")[0].innerHTML = "Select your";
                  stepOneElement.getElementsByClassName("step-name")[0].innerHTML = "SETTING";
                  viewButtonElementStepOne.onclick = () => undefined;
                  removeButtonElementStepOne.onclick = () => undefined;
                  stepTwoElement.setAttribute("class", "step two stone");
                  stepTwoElement.getElementsByClassName("step-title")[0].innerHTML = "Select your";
                  stepTwoElement.getElementsByClassName("step-name")[0].innerHTML = "STONE";
                }
              } else if (setting && !centerStone) {
                removeSetting();
                mainConfigElement.setAttribute("class", "steps-wrap one");
                stepOneElement.setAttribute("class", "step one setting active");
                stepOneElement.getElementsByClassName("step-title")[0].innerHTML = "Select your";
                stepOneElement.getElementsByClassName("step-name")[0].innerHTML = "SETTING";
                viewButtonElementStepOne.onclick = undefined;
                removeButtonElementStepOne.onclick = undefined;
                stepOneElement.getElementsByClassName("price")[0].innerHTML =  "$0";
                stepOneElement.getElementsByTagName("img")[0].setAttribute("src", "");
              }
            }

            removeButtonElementStepTwo.onclick = () => {
              removeCenterStone();
              stepTwoElement.setAttribute("class", "step two stone");
              stepTwoElement.getElementsByTagName("img")[0].setAttribute("src", "");
              stepTwoElement.getElementsByClassName("price")[0].innerHTML = "$0";
              centerStone = undefined;
              viewButtonElementStepTwo.onclick = undefined;
              removeButtonElementStepTwo.onclick = undefined;
              stepThreeElement.setAttribute("class", "step three ring");
              stepThreeElement.getElementsByClassName("price")[0].innerHTML = "$0";
              stepThreeElement.getElementsByTagName("img")[0].setAttribute("src", "");
              viewButtonElementStepThree.onclick = undefined;
            };
          } else if (kcyorPage && kcyorPage == "Stone") {
            mainConfigElement.setAttribute("class", "steps-wrap two");
            stepOneElement.setAttribute("class", "step one setting done");
            stepTwoElement.setAttribute("class", "step two stone active done");
            stepThreeElement.setAttribute("class", "step three ring done");
            $('[data-product-add-cart-text]')?.text(typeBasedStrings[configurationType].button_text)
						theme.strings.addToCart = typeBasedStrings[configurationType].button_text;

            removeButtonElementStepOne.onclick = () => {
              if (setting && centerStone) {
                removeSetting();
                mainConfigElement.setAttribute("class", "steps-wrap one");
                stepOneElement.getElementsByClassName("step-title")[0].innerHTML = "Select your";
                stepOneElement.getElementsByClassName("step-name")[0].innerHTML = "STONE";
                stepOneElement.setAttribute("class", "step one stone done active");
                stepOneElement.getElementsByTagName("img")[0].setAttribute("src", centerStone.image_url);
                stepOneElement.getElementsByClassName("price")[0].innerHTML =  centerStone.isAvailable ? "$" + centerStone.price.toLocaleString("en-US") : "Sold out";

                if (centerStone.product_title.toLowerCase().includes('moissanite')) {
                  stepOneElement.setAttribute('data-stone-type', 'moissanite');
                } else {
                  stepOneElement.setAttribute('data-stone-type', 'diamond');
                }
                
								if (!centerStone.isAvailable) {
									stepOneElement.setAttribute('data-sold-out', true);
									stepOneElement.getElementsByClassName("step-title")[0].innerHTML = "Choose another";
									if (centerStone.product_title.toLowerCase().includes('moissanite')) {
										document.querySelector('[data-stone-not-available-link]').setAttribute('href', "/collections/loose-miossanite");
									}
								}

								for (var [key, value] of Object.entries(centerStone)) {
									var elementsToUpdate = stepOneElement.querySelectorAll(`[data-center-stone-key-value="${key}"]`);
									if(elementsToUpdate) {
										elementsToUpdate.forEach(function(elementToUpdate){
											elementToUpdate.innerHTML = value;
										});
									}
								}

								if (centerStone.product_title.toLowerCase().includes('moissanite')) {
									$('.step .mpsd-certificate-container').hide();
								} else {
									var certificate_lab = "IGI";
									if (centerStone.sku.includes("GIA")) {
										certificate_lab = "GIA";
									}
									stepOneElement.querySelector('[data-center-stone-certificate-image]').setAttribute('src', theme.certificateImages[certificate_lab]);
									stepOneElement.querySelector('[data-center-stone-certificate-url]').setAttribute('href', centerStone.certificate_url);
								}

                viewButtonElementStepOne.onclick = () => window.location.href = "/products/" + centerStone.handle;
                stepTwoElement.getElementsByClassName("step-name")[0].innerHTML = "SETTING";
                stepTwoElement.getElementsByClassName("step-title")[0].innerHTML = "Select your";
                stepTwoElement.setAttribute("class", "step two setting");
                stepTwoElement.getElementsByTagName("img")[0].setAttribute("src", "");
                stepTwoElement.getElementsByClassName("price")[0].innerHTML = "$0";
                viewButtonElementStepTwo.onclick = undefined;
                removeButtonElementStepTwo.onclick = undefined;
                stepThreeElement.setAttribute("class", "step three ring");
                stepThreeElement.getElementsByClassName("price")[0].innerHTML = "$0";
                stepThreeElement.getElementsByTagName("img")[0].setAttribute("src", "");
                viewButtonElementStepThree.onclick = undefined;

                removeButtonElementStepOne.onclick = () => {
                  removeCenterStone();
                  mainConfigElement.setAttribute("class", "steps-wrap one");
                  stepOneElement.setAttribute("class", "step one stone active");
                  stepOneElement.getElementsByClassName("price")[0].innerHTML = "$0";
                  stepOneElement.getElementsByClassName("step-title")[0].innerHTML = "Select your";
                  stepOneElement.getElementsByClassName("step-name")[0].innerHTML = "STONE";
                  viewButtonElementStepOne.onclick = () => undefined;
                  removeButtonElementStepOne.onclick = () => undefined;
                  stepTwoElement.setAttribute("class", "step two setting");
                  stepTwoElement.getElementsByClassName("step-name")[0].innerHTML = "SETTING";
                  stepTwoElement.getElementsByClassName("step-title")[0].innerHTML = "Select your";
                }
              } else if (setting && !centerStone) {
                removeSetting();
                mainConfigElement.setAttribute("class", "steps-wrap one");
                stepOneElement.setAttribute("class", "step one stone active");
                stepOneElement.getElementsByClassName("step-title")[0].innerHTML = "Select your";
                stepOneElement.getElementsByClassName("step-name")[0].innerHTML = "STONE";
                viewButtonElementStepOne.onclick = undefined;
                removeButtonElementStepOne.onclick = undefined;
                stepOneElement.getElementsByClassName("price")[0].innerHTML =  "$0";
                stepOneElement.getElementsByTagName("img")[0].setAttribute("src", "");
                stepTwoElement.setAttribute("class", "step two setting");
                stepTwoElement.getElementsByClassName("step-title")[0].innerHTML = "Select your";
                stepTwoElement.getElementsByClassName("step-name")[0].innerHTML = "SETTING";
                viewButtonElementStepTwo.onclick = undefined;
                removeButtonElementStepTwo.onclick = undefined;
                stepTwoElement.getElementsByClassName("price")[0].innerHTML =  "$0";
                stepTwoElement.getElementsByTagName("img")[0].setAttribute("src", "");
              }
            }

            removeButtonElementStepTwo.onclick = () => {
              removeCenterStone();
              stepTwoElement.setAttribute("class", "step two stone active");
              stepTwoElement.getElementsByTagName("img")[0].setAttribute("src", "");
              stepTwoElement.getElementsByClassName("price")[0].innerHTML = "$0";
              centerStone = undefined;
              viewButtonElementStepTwo.onclick = undefined;
              removeButtonElementStepTwo.onclick = undefined;
              stepThreeElement.setAttribute("class", "step three ring");
              stepThreeElement.getElementsByClassName("price")[0].innerHTML = "$0";
              stepThreeElement.getElementsByTagName("img")[0].setAttribute("src", "");
              viewButtonElementStepThree.onclick = undefined;
            };
          } else if (kcyorPage && kcyorPage == "Complete") {
            mainConfigElement.setAttribute("class", "steps-wrap three");
            stepOneElement.setAttribute("class", "step one setting done");
            stepTwoElement.setAttribute("class", "step two stone done");
            stepThreeElement.setAttribute("class", "step three ring done active");
						if (!centerStone.isAvailable) {
							document.querySelector('[data-stone-not-available-popup]').classList.add('opened');
						}
            removeButtonElementStepOne.onclick = () => {
              removeSetting(true);
            }

            removeButtonElementStepTwo.onclick = () => {
              removeCenterStone(true);
            }

          }
        }

        if (start_with == "Stone") {
          stepOneElement.getElementsByClassName("step-title")[0].innerHTML = "Select your";
          stepOneElement.getElementsByClassName("step-name")[0].innerHTML = "STONE";
          viewButtonElementStepOne.onclick = () => window.location.href = "/products/" + centerStone.handle;
          stepOneElement.getElementsByClassName("price")[0].innerHTML =  centerStone.isAvailable ? "$" + centerStone.price.toLocaleString("en-US") : "Sold out";
          stepOneElement.getElementsByTagName("img")[0].setAttribute("src", centerStone.image_url);

          if (centerStone.product_title.toLowerCase().includes('moissanite')) {
            stepOneElement.setAttribute('data-stone-type', 'moissanite');
          } else {
            stepOneElement.setAttribute('data-stone-type', 'diamond');
          }

					if (!centerStone.isAvailable) {
						stepOneElement.setAttribute('data-sold-out', true);
						stepOneElement.getElementsByClassName("step-title")[0].innerHTML = "Choose another";
						if (centerStone.product_title.toLowerCase().includes('moissanite')) {
							document.querySelector('[data-stone-not-available-link]').setAttribute('href', "/collections/loose-miossanite");
						}
					}

					for (var [key, value] of Object.entries(centerStone)) {
						var elementsToUpdate = stepOneElement.querySelectorAll(`[data-center-stone-key-value="${key}"]`);
						if(elementsToUpdate) {
							elementsToUpdate.forEach(function(elementToUpdate){
								elementToUpdate.innerHTML = value;
							});
						}
					}

					if (centerStone.product_title.toLowerCase().includes('moissanite')) {
						$('.step .mpsd-certificate-container').hide();
					} else {
						var certificate_lab = "IGI";
						if (centerStone.sku.includes("GIA")) {
							certificate_lab = "GIA";
						}
						stepOneElement.querySelector('[data-center-stone-certificate-image]').setAttribute('src', theme.certificateImages[certificate_lab]);
						stepOneElement.querySelector('[data-center-stone-certificate-url]').setAttribute('href', centerStone.certificate_url);
					}


          viewButtonElementStepTwo.onclick = () => window.location.href = "/products/" + setting.handle + "?variant=" + setting.variant_id;
          stepTwoElement.getElementsByClassName("step-name")[0].innerHTML = "SETTING";
          stepTwoElement.getElementsByClassName("step-title")[0].innerHTML = "Select your";
          stepTwoElement.getElementsByClassName("price")[0].innerHTML =  "$" + setting.price.toLocaleString("en-US");
          stepTwoElement.getElementsByTagName("img")[0].setAttribute("src", setting.image_url);

					for (var [key, value] of Object.entries(setting)) {
						var elementsToUpdate = stepTwoElement.querySelectorAll(`[data-setting-key-value="${key}"]`);
						if(elementsToUpdate) {
							elementsToUpdate.forEach(function(elementToUpdate){
								elementToUpdate.innerHTML = value;
							});
						}
					}

          stepThreeElement.getElementsByClassName("price")[0].innerHTML =  "$" + completeRing.price.toLocaleString("en-US");
          stepThreeElement.getElementsByTagName("img")[0].setAttribute("src", setting.image_url);
          viewButtonElementStepThree.onclick = () => window.location.href = "/products/" + completeRing.handle;

          if (kcyorPage && kcyorPage == "Stone") {
            mainConfigElement.setAttribute("class", "steps-wrap one");
            stepOneElement.setAttribute("class", "step one stone active done");
            stepTwoElement.setAttribute("class", "step two setting done");
            stepThreeElement.setAttribute("class", "step three ring done");
            $('[data-product-add-cart-text]')?.text(typeBasedStrings[configurationType].button_text)
						theme.strings.addToCart = typeBasedStrings[configurationType].button_text;

            removeButtonElementStepOne.onclick = () => {
              if (centerStone && setting) {
                removeCenterStone();
                mainConfigElement.setAttribute("class", "steps-wrap two");
                stepOneElement.getElementsByClassName("step-title")[0].innerHTML = "Select your";
                stepOneElement.getElementsByClassName("step-name")[0].innerHTML = "SETTING";
                stepOneElement.setAttribute("class", "step one setting done");
                stepOneElement.getElementsByTagName("img")[0].setAttribute("src", setting.image_url);
                stepOneElement.getElementsByClassName("price")[0].innerHTML =  "$" + setting.price.toLocaleString("en-US");
                viewButtonElementStepOne.onclick = () => window.location.href = "/products/" + setting.handle + "?variant=" + setting.variant_id;

								for (var [key, value] of Object.entries(setting)) {
									var elementsToUpdate = stepOneElement.querySelectorAll(`[data-setting-key-value="${key}"]`);
									if(elementsToUpdate) {
										elementsToUpdate.forEach(function(elementToUpdate){
											elementToUpdate.innerHTML = value;
										});
									}
								}

                stepTwoElement.getElementsByClassName("step-title")[0].innerHTML = "Select your";
                stepTwoElement.getElementsByClassName("step-name")[0].innerHTML = "STONE";
                stepTwoElement.setAttribute("class", "step two stone active");
                stepTwoElement.getElementsByTagName("img")[0].setAttribute("src", "");
                stepTwoElement.getElementsByClassName("price")[0].innerHTML = "$0";
                viewButtonElementStepTwo.onclick = undefined;
                removeButtonElementStepTwo.onclick = undefined;
                stepThreeElement.setAttribute("class", "step three ring");
                stepThreeElement.getElementsByClassName("price")[0].innerHTML = "$0";
                stepThreeElement.getElementsByTagName("img")[0].setAttribute("src", "");
                viewButtonElementStepThree.onclick = undefined;

                removeButtonElementStepOne.onclick = () => {
                  removeSetting();
                  mainConfigElement.setAttribute("class", "steps-wrap one");
                  stepOneElement.setAttribute("class", "step one stone active");
                  stepOneElement.getElementsByClassName("price")[0].innerHTML = "$0";
                  stepOneElement.getElementsByClassName("step-title")[0].innerHTML = "Select your";
                  stepOneElement.getElementsByClassName("step-name")[0].innerHTML = "STONE";
                  viewButtonElementStepOne.onclick = () => undefined;
                  removeButtonElementStepOne.onclick = () => undefined;
                  stepTwoElement.setAttribute("class", "step two setting");
                  stepTwoElement.getElementsByClassName("step-name")[0].innerHTML = "SETTING";
                  stepTwoElement.getElementsByClassName("step-title")[0].innerHTML = "Select your";
                }
              } else if (centerStone && !setting) {
                removeCenterStone();
                mainConfigElement.setAttribute("class", "steps-wrap one");
                stepOneElement.setAttribute("class", "step one stone active");
                stepOneElement.getElementsByClassName("step-title")[0].innerHTML = "Select your";
                stepOneElement.getElementsByClassName("step-name")[0].innerHTML = "STONE";
                viewButtonElementStepOne.onclick = undefined;
                removeButtonElementStepOne.onclick = undefined;
                stepOneElement.getElementsByClassName("price")[0].innerHTML =  "$0";
                stepOneElement.getElementsByTagName("img")[0].setAttribute("src", "");
              }
            }

            removeButtonElementStepTwo.onclick = () => {
              removeSetting();
              stepTwoElement.setAttribute("class", "step two setting");
              stepTwoElement.getElementsByTagName("img")[0].setAttribute("src", "");
              stepTwoElement.getElementsByClassName("price")[0].innerHTML = "$0";
              setting = undefined;
              viewButtonElementStepTwo.onclick = undefined;
              removeButtonElementStepTwo.onclick = undefined;
              stepThreeElement.setAttribute("class", "step three ring");
              stepThreeElement.getElementsByClassName("price")[0].innerHTML = "$0";
              stepThreeElement.getElementsByTagName("img")[0].setAttribute("src", "");
              viewButtonElementStepThree.onclick = undefined;
            };
          } else if (kcyorPage && kcyorPage == "Setting") {
            mainConfigElement.setAttribute("class", "steps-wrap two");
            stepOneElement.setAttribute("class", "step one stone done");
            stepTwoElement.setAttribute("class", "step two setting active done");
            stepThreeElement.setAttribute("class", "step three ring done");
            $('[data-product-add-cart-text]')?.text(typeBasedStrings[configurationType].button_text)
						theme.strings.addToCart = typeBasedStrings[configurationType].button_text;

            removeButtonElementStepOne.onclick = () => {
              if (centerStone && setting) {
                removeCenterStone();
                mainConfigElement.setAttribute("class", "steps-wrap one");
                stepOneElement.getElementsByClassName("step-title")[0].innerHTML = "Select your";
                stepOneElement.getElementsByClassName("step-name")[0].innerHTML = "SETTING";
                stepOneElement.setAttribute("class", "step one setting done active");
                stepOneElement.getElementsByTagName("img")[0].setAttribute("src", setting.image_url);
                stepOneElement.getElementsByClassName("price")[0].innerHTML =  "$" + setting.price.toLocaleString("en-US");

                viewButtonElementStepOne.onclick = () => window.location.href = "/products/" + setting.handle + "?variant=" + setting.variant_id;

								for (var [key, value] of Object.entries(setting)) {
									var elementsToUpdate = stepOneElement.querySelectorAll(`[data-setting-key-value="${key}"]`);
									if(elementsToUpdate) {
										elementsToUpdate.forEach(function(elementToUpdate){
											elementToUpdate.innerHTML = value;
										});
									}
								}

                stepTwoElement.getElementsByClassName("step-title")[0].innerHTML = "Select your";
                stepTwoElement.getElementsByClassName("step-name")[0].innerHTML = "STONE";
                stepTwoElement.setAttribute("class", "step two stone");
                stepTwoElement.getElementsByTagName("img")[0].setAttribute("src", "");
                stepTwoElement.getElementsByClassName("price")[0].innerHTML = "$0";
                viewButtonElementStepTwo.onclick = undefined;
                removeButtonElementStepTwo.onclick = undefined;
                stepThreeElement.setAttribute("class", "step three ring");
                stepThreeElement.getElementsByClassName("price")[0].innerHTML = "$0";
                stepThreeElement.getElementsByTagName("img")[0].setAttribute("src", "");
                viewButtonElementStepThree.onclick = undefined;

                removeButtonElementStepOne.onclick = () => {
                  removeSetting();
                  mainConfigElement.setAttribute("class", "steps-wrap one");
                  stepOneElement.setAttribute("class", "step one setting active");
                  stepOneElement.getElementsByClassName("price")[0].innerHTML = "$0";
                  stepOneElement.getElementsByClassName("step-title")[0].innerHTML = "Select your";
                  stepOneElement.getElementsByClassName("step-name")[0].innerHTML = "SETTING";
                  viewButtonElementStepOne.onclick = () => undefined;
                  removeButtonElementStepOne.onclick = () => undefined;
                  stepTwoElement.setAttribute("class", "step two stone");
                  stepTwoElement.getElementsByClassName("step-title")[0].innerHTML = "Select your";
                  stepTwoElement.getElementsByClassName("step-name")[0].innerHTML = "STONE";
                }
              } else if (centerStone && !setting) {
                removeCenterStone();
                mainConfigElement.setAttribute("class", "steps-wrap one");
                stepOneElement.setAttribute("class", "step one setting active");
                stepOneElement.getElementsByClassName("step-title")[0].innerHTML = "Select your";
                stepOneElement.getElementsByClassName("step-name")[0].innerHTML = "SETTING";
                viewButtonElementStepOne.onclick = undefined;
                removeButtonElementStepOne.onclick = undefined;
                stepOneElement.getElementsByClassName("price")[0].innerHTML =  "$0";
                stepOneElement.getElementsByTagName("img")[0].setAttribute("src", "");
                stepTwoElement.setAttribute("class", "step two stone");
                stepTwoElement.getElementsByClassName("step-title")[0].innerHTML = "Select your";
                stepTwoElement.getElementsByClassName("step-name")[0].innerHTML = "STONE";
                viewButtonElementStepTwo.onclick = undefined;
                removeButtonElementStepTwo.onclick = undefined;
                stepTwoElement.getElementsByClassName("price")[0].innerHTML =  "$0";
                stepTwoElement.getElementsByTagName("img")[0].setAttribute("src", "");
              }
            }

            removeButtonElementStepTwo.onclick = () => {
              removeSetting();
              stepTwoElement.setAttribute("class", "step two setting active");
              stepTwoElement.getElementsByTagName("img")[0].setAttribute("src", "");
              stepTwoElement.getElementsByClassName("price")[0].innerHTML = "$0";
              setting = undefined;
              viewButtonElementStepTwo.onclick = undefined;
              removeButtonElementStepTwo.onclick = undefined;
              stepThreeElement.setAttribute("class", "step three ring");
              stepThreeElement.getElementsByClassName("price")[0].innerHTML = "$0";
              stepThreeElement.getElementsByTagName("img")[0].setAttribute("src", "");
              viewButtonElementStepThree.onclick = undefined;
            };
          } else if (kcyorPage && kcyorPage == "Complete") {
            mainConfigElement.setAttribute("class", "steps-wrap three");
            stepOneElement.setAttribute("class", "step one stone done");
            stepTwoElement.setAttribute("class", "step two setting done");
            stepThreeElement.setAttribute("class", "step three ring done active");

						if (!centerStone.isAvailable) {
							document.querySelector('[data-stone-not-available-popup]').classList.add('opened');
						}

            removeButtonElementStepOne.onclick = () => {
              removeCenterStone(true);
            }

            removeButtonElementStepTwo.onclick = () => {
              removeSetting(true);
            }
          }
        }
      }

      let windowWidth = $(window).width();
  	  $(".step").addClass('no-selection');
      $(".step").click(function(event) {
        if (windowWidth < 600 && !($(event.target).hasClass("view-btn") || $(event.target).hasClass("remove-btn") || $(event.target).hasClass("price") || $(event.target).hasClass("step-image"))) {
          if ($(this).hasClass("done")) {
						if ($(this).attr('data-sold-out')) return;
						if ($(this).hasClass('ring')) {
							if (completeRing && !location.href.includes(completeRing.handle)) {
								window.location.href = '/products/' + completeRing.handle;
							}
						} else {
							if ($(".step-status", this).hasClass("hidden-ziv")) {
	              $(".step-status").toggleClass("hidden-ziv", true)
	              $(".step-status", this).toggleClass("hidden-ziv")
	            } else {
	              $(".step-status").toggleClass("hidden-ziv", true)
	            }
						}
          } else if ($(this).hasClass("setting")) {
						$('[data-continue-to-setting-popup]').addClass('opened');
          } else if ($(this).hasClass("stone")) {
						$('[data-continue-to-center-stone-popup]').addClass('opened');
          }
        } else if (windowWidth < 600 && $(event.target).hasClass("remove-btn")) {
          $(".step-status", this).toggleClass("hidden-ziv")
        } else if (windowWidth >= 600 && !($(event.target).is("img") || $(event.target).hasClass("view-btn") || $(event.target).hasClass("remove-btn") || $(event.target).hasClass("price") || $(event.target).hasClass("step-image"))) {
					if ($(this).attr('data-sold-out')) return;
          if ($(this).hasClass("setting")) {
						if (!$(this).hasClass('done')) {
							$('[data-continue-to-setting-popup]').addClass('opened');
						} else {
	            window.location.href = typeBasedStrings[configurationType].setting_collection_url
						}
          } else if ($(this).hasClass("stone")) {
						if (!$(this).hasClass('done')) {
							$('[data-continue-to-center-stone-popup]').addClass('opened');
						} else {
							if (configurationData.configuration.center_stone.product_title.toLowerCase().includes('moissanite')) {
								window.location.href = "/collections/loose-miossanite"
							} else {
								window.location.href = "/collections/center-stones"
							}
						}
          }
        }
      });
}

function removeSetting(redirect = false) {
  configurationData.configuration.setting = undefined;

  $.ajax({
    url: configUrl,
    type: "PUT",
    cache: false,
    contentType: "application/json; charset=utf-8",
    dataType: "json",
    data: JSON.stringify(configurationData.configuration),
    crossDomain: true,
    xhrFields: {
      withCredentials: true,
    },
  }).then((res) => {
    //console.log(res.data);
    if (redirect) {
      window.location.href = typeBasedStrings[configurationType].setting_collection_url
    }
  });
}

function removeCenterStone(redirect = false) {
	var was_moissanite = configurationData.configuration.center_stone.product_title.toLowerCase().includes('moissanite');
  configurationData.configuration.center_stone = undefined;

  $.ajax({
    url: configUrl,
    type: "PUT",
    cache: false,
    contentType: "application/json; charset=utf-8",
    dataType: "json",
    data: JSON.stringify(configurationData.configuration),
    crossDomain: true,
    xhrFields: {
      withCredentials: true,
    },
  }).then((res) => {
    //console.log(res.data);
    if (redirect) {
			if (was_moissanite) {
				window.location.href = "/collections/loose-miossanite"
			} else {
				window.location.href = "/collections/center-stones"
			}
    }
  });
}

function addSetting(settingToAdd={}, button) {
	if (button) {
		$(".custom-product-add-to-cart-icon", button).html(`<i class="fa fa-spinner fa-spin"></i>`)
	  button.prop('disabled', true);
	}

	if (!settingToAdd.product_id) {
		const settingId = $('#setting-product-id').text();
	  const variantId = $('select.product-id').val();
	  const handle = $('#setting-handle').html();
	  const title = $('#setting-title').html();
	  const image_url = $('.cpt-thumbnails-slide:not(.hidden)').first().find('img').attr('src').replace('1x1', '900x900');
	  const price = Number($("[data-product-price]").html().replace("$", "").replace(",", ""));
	  const compare_at_price = Number($("[data-product-compare-price]").html().replace("$", "").replace(",", ""));
	  const sku = $(".cps-info-value[data-product-sku]").html();
	  const metal = $('[data-variant-option2-value]').html();
	  const metal_purity = $('[data-variant-option3-value]').html();
	  const carat_weight = $('#setting-tcw').html().replace(/[^\d.-]/g, '');
		var shape = $('select.product-id option:selected').data('option1');

	  settingToAdd = {
	    product_id: settingId,
	    variant_id: variantId,
	    handle: handle,
	    product_title: title,
	    image_url: image_url,
	    price: price,
	    compare_at_price: compare_at_price,
	    sku: sku,
	    metal: metal,
	    metal_purity: metal_purity,
	    average_carat_weight: carat_weight
	  };
	}

  configurationData.setting = settingToAdd;

  $.ajax({
    url: configUrl,
    type: "PUT",
    cache: false,
    contentType: "application/json; charset=utf-8",
    dataType: "json",
    data: JSON.stringify(configurationData),
    crossDomain: true,
    xhrFields: {
      withCredentials: true,
    },
  }).then((res) => {
		if (shape) {
			sessionStorage.selected_setting_shape = shape;
		}

		if (res.data.hasOwnProperty("complete_ring")) {
	    location.href = "/products/" + res.data.complete_ring.handle;
		} else {
			if (button) {
        button.prop('disabled', false);
				$(".loader", button).remove();
				button.removeClass('loading-btn');
			}
			$('[data-continue-to-center-stone-popup]').addClass('opened');
		}
  });
}


function addCenterStone(centerStoneToAdd={}) {
  if (!$('span', addStoneButton).html().includes('Sold out')) {
    $(".custom-product-add-to-cart-icon", addStoneButton).html(`<i class="fa fa-spinner fa-spin"></i>`)
    addStoneButton && (addStoneButton.onclick = undefined)

    if (!centerStoneToAdd.product_id)
      centerStoneToAdd = {
        product_id: $("#stone-product-id").text(),
        handle: document.getElementById("stone-handle").innerHTML,
        product_title: document.getElementById("stone-title").innerHTML,
        image_url: document.getElementById("stone-image-url").innerHTML,
        price: document.getElementById("stone-price").innerHTML,
        compare_at_price: document.getElementById("stone-compare-price").innerHTML,
        sku: document.getElementById("stone-sku").innerHTML,
        shape: document.getElementById("stone-shape").innerHTML,
        carat: document.getElementById("stone-carat").innerHTML,
        color: document.getElementById("stone-color").innerHTML,
        cut: document.getElementById("stone-cut").innerHTML,
        polish: document.getElementById("stone-polish").innerHTML,
        symmetry: document.getElementById("stone-symmetry").innerHTML,
        fluorescence: document.getElementById("stone-fluorescence").innerHTML,
        length_to_width: document.getElementById("stone-length-to-width").innerHTML,
        length_to_width_ratio: document.getElementById("stone-length-to-width-ratio").innerHTML,
        certificate: document.getElementById("stone-certificate").innerHTML,
        certificate_url: document.getElementById("stone-certificate-url").innerHTML
      }

    centerStoneToAdd = {
      ...centerStoneToAdd,
      price: +centerStoneToAdd.price,
      compare_at_price: +centerStoneToAdd.compare_at_price
    }

    sessionStorage.selectedStoneShape = centerStoneToAdd.shape;

    configurationData.center_stone = centerStoneToAdd;

		if (configurationData.configuration.setting) {
			$.ajax({
	      url: configUrl,
	      type: "PUT",
	      cache: false,
	      contentType: "application/json; charset=utf-8",
	      dataType: "json",
	      data: JSON.stringify(configurationData),
	      crossDomain: true,
	      xhrFields: {
	        withCredentials: true,
	      },
	    }).then((res) => {
	      if (res.data.hasOwnProperty("complete_ring")) {
	        location.href = "/products/" + res.data.complete_ring.handle
	      } else {
					$('[data-continue-to-setting-popup]').addClass('opened');
	      }
	    });
		} else {
			$.ajax({
	      url: 'https://kcyor.keyzarjewelry.com/api/v1/kcyor/ring-configurations',
	      type: "PUT",
	      cache: false,
	      contentType: "application/json; charset=utf-8",
	      dataType: "json",
	      data: JSON.stringify(configurationData),
	      crossDomain: true,
	      xhrFields: {
	        withCredentials: true,
	      },
	    }).then((res) => {
				$.ajax({
		      url: 'https://kcyor.keyzarjewelry.com/api/v1/kcyor/ring-configurations?settingType=pendant',
		      type: "PUT",
		      cache: false,
		      contentType: "application/json; charset=utf-8",
		      dataType: "json",
		      data: JSON.stringify(configurationData),
		      crossDomain: true,
		      xhrFields: {
		        withCredentials: true,
		      },
		    }).then((res) => {
					$('[data-continue-to-setting-popup]').addClass('opened');
				});
			});
		}
  }
}

async function recoverCompleteProduct() {
  const handle = document.getElementById('complete-ring-hidden-handle').value;

  if (handle) {
    let completeRingToAdd = { handle: handle };

    // populate centerStoneToAdd with data from settingInfoElement
    configurationData.configuration = undefined;
    configurationData.complete_ring = completeRingToAdd;

    let res;

    do {
      res = await $.ajax({
        url: configUrl,
        type: "PUT",
        cache: false,
        contentType: "application/json; charset=utf-8",
        dataType: "json",
        data: JSON.stringify(configurationData),
        crossDomain: true,
        xhrFields: {
          withCredentials: true,
        }
      })

//       console.log(res.data);
    } while (!(res.data.setting && res.data.center_stone && res.data.complete_ring ))
      configurationData = {configuration: res.data};
      renderKCYOR(res.data.setting, res.data.center_stone, res.data.complete_ring, res.data.start_with)
  } else {
    console.log("Not in complete ring page")
  }
}

$(document).on('click', '[data-close-continue-to-center-stone-popup]', function(e) {
	e.preventDefault();
	$('[data-continue-to-center-stone-popup]').removeClass('opened');
});


$(document).on('click', '[data-close-continue-to-setting-popup]', function(e) {
	e.preventDefault();
	$('[data-continue-to-setting-popup]').removeClass('opened');
});
